import './theme.scss';
import 'choices.js/public/assets/styles/choices.min.css';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Choices from "choices.js";
gsap.registerPlugin(ScrollTrigger);

function onLoad() {
   const mmMobile = matchMedia('(max-width: 991px)').matches;

   if (mmMobile) {
      const trigger = document.querySelector('.mobile-nav-trigger');
      const dropdown = document.querySelector('.main-navigation');

      trigger.addEventListener('click', () => {
         trigger.classList.toggle('is-active');
         dropdown.classList.toggle('is-open');
         document.body.classList.toggle('overlay-open');
      });
   }

	function initPinnedSocial() {
		let social = document.querySelector(".article-share");
		if(!social) return;

		let hero = document.querySelector(".hero-banner");
		if(!hero) return;

		if (mmMobile) {
			hero.after(social);
			return;
		}

		// Hero's bottom position relative to <main> (the article-share's positioned parent)
		let mainEl = social.closest("main");
		let heroBottomRelToMain = hero.getBoundingClientRect().bottom - mainEl.getBoundingClientRect().top;
		social.style.top = (heroBottomRelToMain + 50) + "px";

		ScrollTrigger.create({
			trigger: social,
			pin: true,
			start: "top top+=200",
			end: "max",
			pinSpacing: false
		});
	} initPinnedSocial();

	const copyBtn = document.querySelector('.social-share__btn--copy');
	if (copyBtn) {
		copyBtn.addEventListener('click', () => {
			const url = copyBtn.dataset.url;
			if (navigator.clipboard) {
				navigator.clipboard.writeText(url);
			} else {
				const el = document.createElement('textarea');
				el.value = url;
				el.style.cssText = 'position:fixed;opacity:0';
				document.body.appendChild(el);
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);
			}
			copyBtn.setAttribute('title', 'Copied!');
			copyBtn.classList.add('is-copied');
			setTimeout(() => {
				copyBtn.setAttribute('title', 'Copy to clipboard');
				copyBtn.classList.remove('is-copied');
			}, 2000);
		});
	}

	document.querySelectorAll('.blog-filter--category, .blog-filter--author').forEach(select => {
		select._choices = new Choices(select, {
			searchEnabled: false,
			itemSelectText: '',
			shouldSort: false,
		});
	});
}

// set onLoad
window.addEventListener("load", onLoad);
